<template>
	<PortalHeaderNavMobileGeneric
		:is-open="navigationStore.isMobileProfileMenuOpen"
		variant="right"
		@update:is-open="navigationStore.setIsMobileProfileMenuOpen($event)"
	>
		<template #header>
			<NuxtLink to="/perfil">
				<PortalHeaderNavProfileOption variant="mobile" bg-variant="primary" />
			</NuxtLink>
		</template>
		<template #content>
			<section class="flex flex-col items-start justify-between pt-2">
				<div class="relative w-full">
					<template v-for="option in profileOptions" :key="option.route">
						<PortalHeaderNavMobileOptionLink
							:option="option"
							class="w-full px-4 py-[13.5px]"
						/>
					</template>
					<span
						v-if="!user?.hasCompletedRegistration"
						class="absolute inset-y-0 right-1 my-auto size-2 rounded-full bg-tertiary"
					/>
				</div>
			</section>
		</template>
		<template #footer>
			<PortalHeaderNavLogoutButton @logout="handleLogout" />
		</template>
	</PortalHeaderNavMobileGeneric>
</template>

<script setup lang="ts">
import { useEvents } from '~/composables/events/useEvents';
import { useAuthCrossTabSync } from '~/composables/useAuthCrossTabSync';
import { useHeaderNavProfile } from '~/composables/useHeaderNavProfile';
import { useNavigationStore } from '~/store/navigationStore';
import { calculateSessionDurationFromSession } from '~~/utils';

const { clear, user, session } = useUserSession();
const { notifyLogout } = useAuthCrossTabSync();
const navigationStore = useNavigationStore();
const { trackLogoutCompleted } = useEvents();
const { profileOptions } = useHeaderNavProfile();

async function handleLogout() {
	// Session duration in seconds
	const sessionDuration = calculateSessionDurationFromSession(session.value);

	// Call logout API to clear server-side JWT cookies
	await $fetch('/api/_auth/logout', { method: 'POST' });

	// Clear client-side session state
	await clear();

	// Notify other tabs that user has logged out
	notifyLogout();

	trackLogoutCompleted({
		session_duration: sessionDuration
	});

	navigationStore.setIsMobileProfileMenuOpen(false);
}
</script>
